import { TableComponentState } from "../../shared/types/TableComponentState";
import { masterTransactionsTableTabName } from "../../shared/utilities/Constants";
import { createReducer, on } from "@ngrx/store";
import { ActivityReportTableActions, MasterTransactionsTableActions } from "../actions";
import { MasterTransactionsTableColumn } from "../../shared/types/MasterTransactionsTableColumn";
import { MasterStatusViewActions } from "../actions";
import { MasterActivityReportTableColumn } from "../../shared/types/MasterActivityReportTableColumn";

export const masterTransactionsTableStateKey = 'masterTransactionsTableState';

export interface State extends TableComponentState {
  currentTransaction?: MasterTransactionsTableColumn;
  currentActivityReport?: MasterActivityReportTableColumn;
  currentTemplate?: string;
  currentTab: masterTransactionsTableTabName | '';
}

export const initialMasterTransactionsTableState: State = {
  currentTab: '',
  isInitialLoad: true,
  gridReady: false,
  printClicked: false,
  loading: false,
  error: '',
  hasError: false,
  currentTransaction: {
    'Account name': '',
    "Account number": "",
    "Registration type": "",
    "Process date": "",
    "Type": "internal-transfer",
    "To/From": "",
    Direction: "Incoming",
    Amount: "",
    "Available cash": ""
  },
   currentActivityReport: {
    'ActivityReportDownload': '',
    "Date": ""
  }
}

export const masterTransactionsTableStateReducer = createReducer(
  initialMasterTransactionsTableState,
  on(MasterTransactionsTableActions.gridReady, (state, action) => {
    return {
      ...state,
      gridReady: action.gridReady,
      currentTab: action.tab
    };
  }),
  on(
    MasterTransactionsTableActions.hasEmptyResponse,
    ActivityReportTableActions.hasEmptyActivityReportResponse,
     (state) => {
    return {
      ...state,
      hasEmptyResponse: true,
      loading: false,
      error: '',
      hasError: false,
      cancelLinkClicked: false,
      isInitialLoad: false
    }
  }),
  on(
    MasterTransactionsTableActions.currentTabUpdated,
     (state, {currentTab}) => {
    return {
      ...state,
      currentTab: currentTab,
      hasError: false,
    }
  }),
  on(
    MasterStatusViewActions.getMasterTransactionsList,
    MasterStatusViewActions.refreshMaster,
    MasterTransactionsTableActions.currentTabUpdated,
    MasterStatusViewActions.getBookmarkedAccounts,
    ActivityReportTableActions.getActivityReports,
    (state) => {
      return {
        ...state,
        loading: true,
        error: '',
        hasError: false,
        cancelLinkClicked: true
      }
    }
  ),
  on(
    MasterStatusViewActions.callTransactionsSuccess,
    ActivityReportTableActions.callActivityReportsSuccess, 
    (state) => {
    return {
      ...state,
      loading: false,
      error: '',
      hasError: false,
      cancelLinkClicked: false
    }
  }),
  on(
    MasterStatusViewActions.callTransactionsFailure,
    ActivityReportTableActions.callActivityReportsFailure,
    (state, err) =>{
    return {
      ...state,
      loading: false,
      error: err.message,
      hasError: true,
      cancelLinkClicked: false
    }
  })
);